/* global window */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import path from 'path'

const ASSET_URL = 'https://apprentus.imgix.net'

export function retinaSrc (src) {
  if (!src) {
    return `${ASSET_URL}/assets/design/default_avatar.png`
  }
  let basename = path.basename(src, path.extname(src))
  basename = basename + '@2x' + path.extname(src)
  return src.replace(path.basename(src), basename)
}

export function isRetina () {
  return typeof window !== 'undefined' && window.devicePixelRatio >= 2
}

export function assetUrl (src) {
  if (src.indexOf('/') === 0) {
    return ASSET_URL + src
  }
  return src
}

export default class Img extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    retina: PropTypes.string
  }

  render () {
    const props = Object.assign({}, this.props, {
      src: assetUrl(isRetina() ? this.props.retina || retinaSrc(this.props.src) : this.props.src)
    })

    return <img {...props} />
  }
}
